module.exports = __webpack_public_path__ + "img/downarrow.5af5481a.svg";